import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import "./UserSelect.css"
import React, {useEffect, useState} from "react";
import RootState from "../../../redux/states/root.state";
import { fetchUsers } from "../../../redux/actions/users.actions";
import { CircularProgress, Pagination, Button, TextField, Radio, FormControlLabel, List, ListItem, ListItemButton, ListItemText, ListItemIcon, Box, Typography, RadioGroup } from "@mui/material";
import usePermissionCheck from "../../../hooks/usePermissionCheck";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";

interface UserSelectProps {
    setSelectedUser: any;
    currentUser: any;
    role?: string|null;
}

const UserSelect: React.FC<UserSelectProps> = ({ setSelectedUser, currentUser, role=null}) => {
const dispatch: AppDispatch = useDispatch();
const {data:users,meta,loading} = useSelector((state: RootState) => state.users);
const [pageNumber, setPageNumber] = useState(1);
const [email, setEmail] = useState(``);
const [emailQuery, setEmailQuery] = useState<any>(null);
const {canAccess:canDeregisterUser} = usePermissionCheck(['deregister_from_user']);

useEffect(() => {
    setEmail(currentUser?.email??'')
  }, [currentUser]);

useEffect(() => {
    let query = `page=${pageNumber}`;

    if (role) query += `&role=${role}`;

    if (emailQuery){
        query += `&email=${emailQuery}`
    }
    dispatch(fetchUsers(query))
  }, [dispatch,pageNumber, emailQuery, role]);

useEffect(() => {
    setEmail(currentUser?.email??'')
  }, [currentUser]);

  return (
    <>
    
    <div className="user-search-container">
        <TextField type="search" placeholder="Search email..." onChange={(e)=>setEmail(e.target.value)} value={email} size="small" fullWidth/>
        <Button type="button" variant="contained" onClick={()=>setEmailQuery(email)} size="small">Search</Button>
    </div>

    {loading ?
        <div className="no-users"><CircularProgress size={"24px"}/></div>
        :
    users.length>0 ? 
        <div className="select-container">
            <RadioGroup
                value={currentUser === null || currentUser === 'none' ? 'none' : (currentUser?.id || '')}
            >
                <List 
                    dense
                    sx={{
                        maxHeight: 200,
                        overflow: 'auto',
                        '&::-webkit-scrollbar': {
                            width: '8px',
                        },
                        '&::-webkit-scrollbar-track': {
                            backgroundColor: 'rgba(0,0,0,0.1)',
                            borderRadius: '4px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(0,0,0,0.3)',
                            borderRadius: '4px',
                            '&:hover': {
                                backgroundColor: 'rgba(0,0,0,0.5)',
                            },
                        },
                    }}
                >
                    {canDeregisterUser && <ListItem disablePadding>
                        <ListItemButton
                            onClick={() => setSelectedUser('none')}
                            selected={currentUser === null || currentUser === 'none'}
                            sx={{
                                borderRadius: 1,
                                alignItems: 'flex-start',
                                border: '1px dashed',
                                borderColor: 'var(--font-red)',
                                backgroundColor: 'transparent',
                                mb: 1,
                                pb: 0.5,
                                '&:hover': {
                                    backgroundColor: 'color-mix(in srgb, var(--font-red) 10%, transparent)',
                                },
                                '&.Mui-selected': {
                                    border: '1px solid',
                                    borderColor: 'var(--as-red)',
                                    backgroundColor: 'var(--as-red)',
                                    '&:hover': {
                                        backgroundColor: 'color-mix(in srgb, var(--as-red) 85%, black)',
                                    },
                                    '& .MuiTypography-root': {
                                        color: '#fff',
                                    },
                                    '& .MuiRadio-root, & .MuiSvgIcon-root': {
                                        color: '#fff',
                                    },
                                },
                            }}
                        >
                            <ListItemIcon sx={{ minWidth: 'auto', mr: 1, mt: '6px', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                <Radio
                                    value="none"
                                    size="small"
                                    sx={{ p: 0, color: 'var(--font-red)' }}
                                />
                                <PersonRemoveIcon fontSize="small" sx={{ color: 'var(--font-red)' }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography
                                        variant="body2"
                                        sx={{ fontWeight: 700, color: 'var(--font-red)' }}
                                    >
                                        Deregister
                                    </Typography>
                                }
                                secondary={
                                    <Typography variant="caption" sx={{ color: 'var(--font-black)' }}>
                                        Remove this spa's owner
                                    </Typography>
                                }
                            />
                        </ListItemButton>
                    </ListItem>}
                    {users.map((user: any) => (
                        <ListItem key={user?.id} disablePadding>
                            <ListItemButton
                                onClick={() => setSelectedUser(user)}
                                selected={user?.id === currentUser?.id}
                                sx={{ borderRadius: 1 }}
                            >
                                <ListItemIcon>
                                    <Radio 
                                        value={user?.id} 
                                        size="small"
                                    />
                                </ListItemIcon>
                                <ListItemText
                                    primary={
                                        <Typography variant="body2">
                                            {user?.name !== '' ? `${user?.name} (${user?.email})` : user?.email}
                                        </Typography>
                                    }
                                />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </RadioGroup>
            {
            meta?.last_page>1 &&
            <Pagination 
                count={meta?.last_page} 
                size="small"
                onChange={(e,page)=>setPageNumber(page)}
                page={pageNumber}
                showLastButton 
                showFirstButton 
                disabled={meta?.last_page===1}
            />
            }
        </div>
        :
        <div>No Users Found.</div>
    }
    </>
  );
};

export default UserSelect;
